document.addEventListener('DOMContentLoaded', () => {
  const menu = document.querySelector('.menu-toggle');
  const nav = document.querySelector('.main-nav');
  menu?.addEventListener('click', () => {
    const open = nav.classList.toggle('open');
    menu.setAttribute('aria-expanded', String(open));
  });

  const filterButton = document.querySelector('.filter-toggle');
  filterButton?.addEventListener('click', () => document.querySelector('.filters')?.classList.toggle('open'));

  const mainImage = document.querySelector('#ProductMainImage');
  document.querySelectorAll('.product-thumbs button').forEach(button => {
    button.addEventListener('click', () => {
      if (mainImage) mainImage.src = button.dataset.image;
    });
  });

  document.querySelectorAll('.unit').forEach(button => {
    button.addEventListener('click', () => {
      document.querySelectorAll('.unit').forEach(item => item.classList.remove('active'));
      button.classList.add('active');
    });
  });

  document.querySelectorAll('.shopify-product-tabs').forEach(tabs => {
    tabs.querySelectorAll('.theme-tab').forEach(button => {
      button.addEventListener('click', () => {
        tabs.querySelectorAll('.theme-tab').forEach(item => item.classList.remove('active'));
        tabs.querySelectorAll('.theme-tab-panel').forEach(panel => panel.hidden = true);
        button.classList.add('active');
        const panel = tabs.querySelector(`#${button.dataset.target}`);
        if (panel) panel.hidden = false;
      });
    });
  });

  const pawMainImage = document.querySelector('.paw-main-image img');
  document.querySelectorAll('.paw-thumbnails button').forEach(button => {
    button.addEventListener('click', () => {
      if (pawMainImage) pawMainImage.src = button.dataset.image;
    });
  });

  const pawVariant = document.querySelector('#PawVariantId');
  const pawPrice = document.querySelector('#PawPrice');
  document.querySelectorAll('.paw-material').forEach(button => {
    button.addEventListener('click', () => {
      document.querySelectorAll('.paw-material').forEach(item => item.classList.remove('active'));
      button.classList.add('active');
      if (pawVariant) pawVariant.value = button.dataset.variant;
      if (pawPrice) {
        const symbol = window.PawProduct?.currency || '₹';
        pawPrice.textContent = `${symbol}${(Number(button.dataset.price) / 100).toLocaleString(undefined, {minimumFractionDigits: 2})}`;
      }
    });
  });

  document.querySelectorAll('.paw-unit').forEach(button => {
    button.addEventListener('click', () => {
      document.querySelectorAll('.paw-unit').forEach(item => item.classList.remove('active'));
      button.classList.add('active');
      const unit = document.querySelector('#PawUnit');
      if (unit) unit.value = button.dataset.unit;
    });
  });

  document.querySelectorAll('[data-home-slider]').forEach(slider => {
    const track = slider.querySelector('[data-slider-track]');
    const slides = [...slider.querySelectorAll('.home-slide')];
    const dots = [...slider.querySelectorAll('[data-slide-dot]')];
    if (!track || slides.length < 2) return;

    let current = 0;
    let timer;
    let touchStart = 0;
    const delay = Number(slider.dataset.autoplay) || 5000;

    const showSlide = index => {
      current = (index + slides.length) % slides.length;
      track.style.transform = `translateX(-${current * 100}%)`;
      slides.forEach((slide, slideIndex) => slide.setAttribute('aria-hidden', String(slideIndex !== current)));
      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('active', dotIndex === current);
        if (dotIndex === current) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };

    const stop = () => window.clearInterval(timer);
    const start = () => {
      stop();
      timer = window.setInterval(() => showSlide(current + 1), delay);
    };

    dots.forEach(dot => dot.addEventListener('click', () => {
      showSlide(Number(dot.dataset.slideDot));
      start();
    }));
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    slider.addEventListener('focusin', stop);
    slider.addEventListener('focusout', start);
    slider.addEventListener('touchstart', event => {
      touchStart = event.changedTouches[0].clientX;
      stop();
    }, { passive: true });
    slider.addEventListener('touchend', event => {
      const distance = event.changedTouches[0].clientX - touchStart;
      if (Math.abs(distance) > 45) showSlide(current + (distance < 0 ? 1 : -1));
      start();
    }, { passive: true });
    start();
  });

  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartOverlay = document.querySelector('[data-cart-drawer-overlay]');
  const cartOpenButton = document.querySelector('[data-cart-drawer-open]');
  const cartCloseButton = document.querySelector('[data-cart-drawer-close]');
  const cartItems = document.querySelector('[data-cart-drawer-items]');
  const cartFooter = document.querySelector('[data-cart-drawer-footer]');
  const cartTotal = document.querySelector('[data-cart-drawer-total]');
  const cartCount = document.querySelector('[data-cart-count]');

  if (cartDrawer && cartOverlay && cartOpenButton && cartItems) {
    const escapeHtml = value => String(value ?? '').replace(/[&<>"']/g, character => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;'
    })[character]);

    const formatMoney = (cents, currency = 'INR') => new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency,
      maximumFractionDigits: 2
    }).format((Number(cents) || 0) / 100);

    const renderCart = cart => {
      const count = Number(cart.item_count) || 0;
      if (cartCount) {
        cartCount.textContent = String(count);
        cartCount.classList.toggle('is-empty', count === 0);
      }
      if (cartTotal) cartTotal.textContent = formatMoney(cart.total_price, cart.currency || 'INR');
      if (cartFooter) cartFooter.hidden = count === 0;

      if (!count) {
        cartItems.innerHTML = '<div class="cart-drawer-empty"><p>Your cart is empty.</p><a class="pink-button" href="/collections/all">SHOP WALLPAPERS</a></div>';
        return;
      }

      cartItems.innerHTML = cart.items.map(item => {
        const imageSeparator = item.image && item.image.includes('?') ? '&' : '?';
        const image = item.image
          ? `<img src="${escapeHtml(item.image)}${imageSeparator}width=164" alt="${escapeHtml(item.product_title)}" width="82" height="82">`
          : '<span></span>';
        const details = item.variant_title && item.variant_title !== 'Default Title'
          ? `<small>${escapeHtml(item.variant_title)}</small>`
          : '';
        const properties = Object.entries(item.properties || {})
          .filter(([name, value]) => name.charAt(0) !== '_' && value !== null && value !== '')
          .map(([name, value]) => {
            const propertyValue = String(value);
            const renderedValue = /^(https?:\/\/|\/)/i.test(propertyValue)
              ? `<a href="${escapeHtml(propertyValue)}" target="_blank" rel="noopener">${escapeHtml(propertyValue)}</a>`
              : escapeHtml(propertyValue);
            return `<small><strong>${escapeHtml(name)}:</strong> ${renderedValue}</small>`;
          }).join('');
        return `<article class="cart-drawer-item">
          <a href="${escapeHtml(item.url)}">${image}</a>
          <div class="cart-drawer-item-copy">
            <a href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>
            ${details}
            <div class="cart-drawer-properties">${properties}</div>
            <small><strong>Quantity:</strong> ${Number(item.quantity) || 1}</small>
            <button type="button" data-cart-remove="${escapeHtml(item.key)}">Remove</button>
          </div>
          <div class="cart-drawer-item-price">${formatMoney(item.final_line_price, cart.currency || 'INR')}</div>
        </article>`;
      }).join('');
    };

    const refreshCart = async () => {
      const response = await fetch(cartDrawer.dataset.cartJson || '/cart.js', {
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      });
      if (!response.ok) throw new Error('Unable to load cart.');
      const cart = await response.json();
      renderCart(cart);
      return cart;
    };

    const openCart = async () => {
      cartOverlay.hidden = false;
      document.body.classList.add('cart-drawer-open');
      requestAnimationFrame(() => {
        cartOverlay.classList.add('is-open');
        cartDrawer.classList.add('is-open');
      });
      cartDrawer.setAttribute('aria-hidden', 'false');
      cartOpenButton.setAttribute('aria-expanded', 'true');
      try {
        await refreshCart();
      } catch (error) {
        cartItems.innerHTML = '<p class="cart-drawer-empty">Your cart could not be loaded. <a href="/cart">View cart</a></p>';
      }
    };

    const closeCart = () => {
      cartOverlay.classList.remove('is-open');
      cartDrawer.classList.remove('is-open');
      cartDrawer.setAttribute('aria-hidden', 'true');
      cartOpenButton.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('cart-drawer-open');
      window.setTimeout(() => { cartOverlay.hidden = true; }, 350);
    };

    cartOpenButton.addEventListener('click', openCart);
    cartCloseButton?.addEventListener('click', closeCart);
    cartOverlay.addEventListener('click', closeCart);
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && cartDrawer.classList.contains('is-open')) closeCart();
    });
    cartItems.addEventListener('click', async event => {
      const removeButton = event.target.closest('[data-cart-remove]');
      if (!removeButton) return;
      removeButton.disabled = true;
      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: removeButton.dataset.cartRemove, quantity: 0 })
        });
        if (!response.ok) throw new Error('Unable to remove item.');
        renderCart(await response.json());
      } catch (error) {
        removeButton.disabled = false;
      }
    });
    document.addEventListener('cart:refresh', () => refreshCart().catch(() => {}));
    document.addEventListener('wallpaper-configurator:cart-add', () => openCart());
  }
});
